import {
	isOrderAuditNotification,
	NotificationCategory,
} from '../OrdersTable/interfaces/Order.interface';

/**
 * The navbar counter shows how many orders have unread notifications, so it
 * counts distinct groups, not notifications. New-product and audit
 * notifications have their own surfaces and do not count.
 */
export const countUnreadOrderGroups = (
	items: { category: string; groupId: string }[] = [],
): number =>
	new Set(
		items
			.filter(
				(item) =>
					item.category !== NotificationCategory.NEW_PRODUCT &&
					!isOrderAuditNotification(item),
			)
			.map((item) => item.groupId),
	).size;
